export default __webpack_public_path__ + "static/media/aafiyah.d07be522.png";